import { render, staticRenderFns } from "./newContactForm.vue?vue&type=template&id=66add9aa&"
import script from "./newContactForm.vue?vue&type=script&lang=js&"
export * from "./newContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports